export const getTime_api = {
	url: 'maijiaDownloadtime',
	method: 'get'
}
export const getpf_api = {
	url: 'getmaijiaprofession',
	method: 'get'
}

export const mergeList = [
	{
		name: '1到2',
		code: '1-2'
	},
	{
		name: '1到3',
		code: '1-3'
	},
	{
		name: '1到4',
		code: '1-4'
	},
	{
		name: '1到5',
		code: '1-5'
	},
	{
		name: '1到6',
		code: '1-6'
	}
]



// WEBPACK FOOTER //
// ./src/views/maijia/maijia-professionbrandtop/desc.js